import configs from './config.json';
import {Api} from "./Api";
import {UserApi} from "./UserApi";

export class CoWorkApi {
    static getCoWork = async (data, response, error) => {
        await Api.get(`${configs.coWork}/${data}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static getAllCoWork = async ( page,response, error) => {
        await Api.get(`all-coworks/${page}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static insertCoWork = async (data, response, error) => {
        await Api.post(`${configs.coWork}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static deleteCoWork = async (id, response, error) => {
        await Api.delete(`${configs.coWork}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }
}